import React from 'react';
import styled from 'styled-components';
import { animated, useSpring, config } from 'react-spring';
import PropTypes from 'prop-types';

const StyledHamburger = styled(animated.button)`
  appearance: none;
  border: none;
  background: none;
  border-radius: 0px;
  outline: none;
  &:focus {
    border: solid 1px ${({ theme }) => theme.global.colors['status-focus']};
  }

  cursor: pointer;
  height: 44px;
  width: 44px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;

  @media ${({ theme }) => theme.custom.layouts.above_large} {
    display: none;
  }

  > div {
    width: 40px;
    height: 5px;
    background: black;
    &:nth-of-type(2) {
      margin-top: 5px;
      margin-bottom: 5px;
    }
  }
`;

const Hamburger = ({ isOpen, onClick }) => {
  const centerAnimation = useSpring({
    from: {
      width: '40px',
      opacity: 1,
    },
    to: {
      width: isOpen ? '0px' : '40px',
      opacity: isOpen ? 0 : 1,
    },
    config: config.stiff,
  });

  const bottomAnimation = useSpring({
    from: {
      transform: `translate(0px, 0px) rotate(0deg)`,
    },
    to: {
      transform: isOpen
        ? `translate(0px, -10px) rotate(45deg)`
        : `translate(0px, 0px) rotate(0deg)`,
    },
    config: config.stiff,
  });

  const topAnimation = useSpring({
    from: {
      transform: `translate(0px, 0px) rotate(0deg)`,
    },
    to: {
      transform: isOpen
        ? `translate(0px, 10px) rotate(-45deg)`
        : `translate(0px, 0px) rotate(0deg)`,
    },
    config: config.stiff,
  });

  return (
    <StyledHamburger aria-label="Mobile Menu Toggle" onClick={onClick}>
      <animated.div style={topAnimation} />
      <animated.div style={centerAnimation} />
      <animated.div style={bottomAnimation} />
    </StyledHamburger>
  );
};

Hamburger.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Hamburger;
